<template>
  <div class="ui-notifications">
    <ui-notification
      v-for="notif in notifications"
      :key="'notif_'+notif.id"
      :notification="notif"
      />
  </div>
</template>

<script setup lang="ts">
import { notifications } from '~/composables/Notifications'

onMounted(() => {
  // addNotification({
  // 	text: 'This is a test notification',
  // 	type: 'info'
  // })
})
</script>
